import { Button } from '@alfa-bank/site-button-v2';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Img } from '@alfa-bank/site-img';

import { CommonLinkDesktop as CommonLink } from '../components/common-link/desktop';
import { IconChevronUp } from '../components/icon-chevron-up';
import { MainMenuLinkDesktop as MainMenuLink } from '../components/main-menu-link/desktop';
import { StickyHeader } from '../components/sticky-header';
import type { TX5BankHeaderV2Desktop, IDepsDesktop } from '../models';

import { X5BankHeaderV2Desktop as Component } from './desktop';
import styles from './desktop.css';

export const X5BankHeaderV2Desktop = createWidget<IDepsDesktop, TX5BankHeaderV2Desktop>({
    CommonLink,
    Button,
    IconChevronUp,
    StickyHeader,
    styles,
    MainMenuLink,
    Layout,
    Img,
})(Component);
